import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import processesService from 'services/processesService';

import { open, save, types } from './actions';
import { MODES } from './constants';
import { getMode, getWorkflowId } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiateDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveWorkflow);
}

function* watchInitiateDrawer(action) {
  try {
    const { callBack } = action.payload;
    const mode = yield select(getMode);
    const workSteps = yield call(processesService.workSteps.list);
    let workflow = null;
    if (mode == MODES.EDIT) {
      const workflowId = yield select(getWorkflowId);
      workflow = yield call(processesService.workflows.get, workflowId);
    }

    yield put(open.success({ workflow, workSteps }));

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      const workflow = action.payload.workflow;
      yield call(callBack, { workflow });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveWorkflow(action) {
  try {
    const { workStepIds } = action.payload;

    const requestData = {
      workStepIds,
    };

    const mode = yield select(getMode);
    const workflowId = yield select(getWorkflowId);
    let workflow;
    if (mode == MODES.CREATE) {
      workflow = yield call(processesService.workflows.create, requestData);
    } else {
      workflow = yield call(
        processesService.workflows.update,
        workflowId,
        requestData,
      );
    }

    yield put(save.success({ workflow }));
  } catch (error) {
    yield put(save.error(error));
  }
}
